import { useState } from 'react';
import { ORIGIN_TABLE_MAP } from 'features/daily-plan/constants';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { SelectionType } from 'UI/constants/defaults';
import { Endpoints } from 'UI/constants/endpoints';
import { ContactEntityMapping, ENTITY_TYPE_ID_MAP } from 'UI/constants/entityTypes';
import { FeatureFlags } from 'UI/constants/featureFlags';

const getEntityTypePerItem = ({ table, item }) => {
  const itemName = item.type?.toLowerCase();
  const OBJECT_TO_EXTRACT_BY_ENTITY_TABLE = {
    [ORIGIN_TABLE_MAP.Candidates]: ENTITY_TYPE_ID_MAP[itemName],
    [ORIGIN_TABLE_MAP.Contacts]: ENTITY_TYPE_ID_MAP[ContactEntityMapping[item.type_id]],
    [ORIGIN_TABLE_MAP.Companies]: ENTITY_TYPE_ID_MAP[itemName],
    [ORIGIN_TABLE_MAP.ResumeSearch]: ENTITY_TYPE_ID_MAP[itemName]
  };

  return OBJECT_TO_EXTRACT_BY_ENTITY_TABLE[table];
};

// TODO: Adjust endpoints when backend team adds support for multiple keywords creation
const ENDPOINT_TO_ENTITY_TYPE_MAP = {
  [ORIGIN_TABLE_MAP.Candidates]: `${Endpoints.Candidates}/keywords`,
  [ORIGIN_TABLE_MAP.Contacts]: `${Endpoints.Names}/keywords`,
  [ORIGIN_TABLE_MAP.Companies]: `${Endpoints.Companies}/keywords`,
  [ORIGIN_TABLE_MAP.ResumeSearch]: `${Endpoints.Candidates}/keywords`
};

export const useKeywordDrawerManager = ({
  table,
  selectedItems = [],
  selectionType = 'include'
}) => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const canCreateMultipleKeywords =
    checkIfFeatureFlagEnabled(FeatureFlags.MultipleKeywordsFromList) &&
    selectionType === SelectionType.Include;
  const [isKeywordDrawerOpen, setIsKeywordDrawerOpen] = useState(false);
  const handleOpenKeywordDrawer = () => setIsKeywordDrawerOpen(true);
  const handleCloseKeywordDrawer = () => setIsKeywordDrawerOpen(false);
  const keywordEndpoint = ENDPOINT_TO_ENTITY_TYPE_MAP[table];

  const formattedSelectedItems = selectedItems?.map(item => {
    return {
      entityId: item.id,
      entityTypeId: getEntityTypePerItem({ table, item })
    };
  });

  return {
    canCreateMultipleKeywords,
    formattedSelectedItems,
    handleCloseKeywordDrawer,
    handleOpenKeywordDrawer,
    isKeywordDrawerOpen,
    keywordEndpoint
  };
};
